module.exports = __webpack_public_path__ + "static/assets/3e182b41734678b1add80c4ffeccec6a.svg";